import { Component, Input } from '@angular/core';

@Component({
    selector: 'sgt-table-perc-progress',
    templateUrl: './table-perc-progress.component.html',
    styleUrls: ['./table-perc-progress.component.less']
})
export class TablePercProgressComponent {
    /** Percentual do progress */
    @Input() perc: number;
}
